exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__front___8t_eb{position:absolute;width:100%;height:100%;backface-visibility:hidden;top:0;left:0;z-index:2;transform:rotateY(0deg);border-radius:.25rem;overflow:hidden}", ""]);

// exports
exports.locals = {
	"front": "styles__front___8t_eb"
};